import { AlertCircle, X } from 'lucide-react';

interface AIRetestConflictDialogProps {
  onClose: () => void;
}

export const AIRetestConflictDialog = ({ onClose }: AIRetestConflictDialogProps) => {
  return (
    <div data-component="AIRetestConflictDialog" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
        <div className="flex items-start gap-3">
          <AlertCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">AI Evaluation In Progress</h3>
            <p className="text-sm text-gray-600">
              Another AI evaluation is currently running. Please wait for it to complete before starting a new one.
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};
